package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.radar.options.TickOptions

@Suppress("unused")
@RadarDsl
class TickScope {
    var display: Boolean = true
    private var color: JSScriptable<ChartColor>? = null
    private var backdropColor: JSScriptable<ChartColor>? = null
    var stepSize: Float? = null
    var count: Int? = null
    var maxTicksLimit: Int? = null

    fun color(value: ChartColor) { color = JSScriptable.Static(value) }
    fun color(fn: (dynamic) -> ChartColor) { color = JSScriptable.Scriptable(fn) }

    fun backdropColor(value: ChartColor) { backdropColor = JSScriptable.Static(value) }
    fun backdropColor(fn: (dynamic) -> ChartColor) { backdropColor = JSScriptable.Scriptable(fn) }

    internal fun build() = TickOptions(
        display = display,
        color = color,
        backdropColor = backdropColor,
        stepSize = stepSize,
        count = count,
        maxTicksLimit = maxTicksLimit,
    )
}
